import { PageWrapper } from "@/components/ui/PageWrapper";
import { Box, Flex, Text } from "@givenwell/components";
import { MailIcon } from "@givenwell/core-solid-icons";
import { colors } from "@givenwell/theme";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/campaigns/")({
  component: CampaignsOverview,
});

function CampaignsOverview() {
  return (
    <PageWrapper title="Campaigns">
      <Flex css={{ gap: 16, flexWrap: "wrap" }}>
        <NavCard
          to="/campaigns/templates"
          title="Templates"
          description="Create and manage reusable email templates with markdown and variable injection."
        />
        <NavCard
          to="/campaigns/segments"
          title="Segments"
          description="Build composable audience segments with AND/OR filter logic."
        />
        <NavCard
          to="/campaigns/sends"
          title="Sends"
          description="Send bulk emails to segments using templates. View send history and recipient tracking."
        />
      </Flex>
    </PageWrapper>
  );
}

function NavCard({ to, title, description }: { to: string; title: string; description: string }) {
  return (
    <Link to={to} style={{ textDecoration: "none", flex: "1 1 280px" }}>
      <Box
        css={{
          p: 24,
          background: "white",
          rounded: 12,
          border: `1px solid ${colors.outline}`,
          cursor: "pointer",
          transition: "box-shadow 0.15s",
          "&:hover": { boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
        }}
      >
        <Flex css={{ gap: 12, items: "center", mb: 8 }}>
          <MailIcon style={{ color: colors.text2 }} />
          <Text css={{ fontScale: "lg", fontWeight: 600 }}>{title}</Text>
        </Flex>
        <Text css={{ fontScale: "sm", color: colors.text2 }}>{description}</Text>
      </Box>
    </Link>
  );
}
